// Services
import { AppTranslationService } from "#/api/AppTranslationService";
import { PageService } from "#/api/PageService";
import { ConversionWorldService } from "#/api/ConversionWorldService";
import { AppUbersetzungService } from "@mgs/ci2019-common/src/services/AppUbersetzungService";
import { KatalogService } from "#/api/KatalogService";
import { PersonService } from "#/api/PersonService";
import { DashboardService } from "#/api/DashboardService";
import { KpiService } from "#/api/KpiService";
import { AuthService } from "#/api/AuthService";
import { IdentityService } from "./IdentityService";
import { WarenkorbService } from "./WarenkorbService";
import { UnimogService } from "./UnimogService";
import { HaendlersucheService } from "./HaendlersucheService";
import { PitService } from "./PitService";

export class Api {
  public static readonly appUbersetzungService: AppUbersetzungService =
    AppUbersetzungService.instance;
  public static readonly pageService: PageService = PageService.instance;
  public static readonly conversionWorldService: ConversionWorldService =
    ConversionWorldService.instance;
  public static readonly katalogService: KatalogService =
    KatalogService.instance;
  public static readonly pitService: PitService = PitService.instance;
  public static readonly personService: PersonService = PersonService.instance;
  public static readonly dashboardService: DashboardService =
    DashboardService.instance;
  public static readonly kpiService: KpiService = KpiService.instance;
  public static readonly authService: AuthService = AuthService.instance;
  public static readonly identity: IdentityService = IdentityService.instance;
  public static readonly warenkorb: WarenkorbService =
    WarenkorbService.instance;
  public static readonly unimog: UnimogService = UnimogService.instance;
  public static readonly haendlersuche: HaendlersucheService =
    HaendlersucheService.instance;
}
